angular.module('impactx').service('searchFilter', ['dataGen', '$q', '$redirect', 'SearchFilter', function (dataGen, $q, $redirect, SearchFilter) {
    var searchFilter = this;
    this.searchFilterData = {};
    this.trns = {};
    /* separate definition to use for double data binding */
    this.searchInput = '';
    this.searchInputGlobal = '';
    this.otherSearchInput = undefined;
    this.wasInitialized = false;
    this.promise = null;
    this.listSearch = {value: false};
    this.manufacturerId = null;
    this.selectedEClass = null;

    function resetDetailFilter() {
        var tempData = {};
        // searchFilter.wasInitialized = true;
        searchFilter.promise = dataGen.getData(tempData, {}, "/search/filter", null, true).then(function () {
            searchFilter.wasInitialized = true;
            //Store configured values
            var procurementGroup = searchFilter.searchFilterData.procurementGroup;
            var productFamily = searchFilter.searchFilterData.productFamily;
            var tenderFilter = impactX.isDefined(searchFilter, "searchFilterData.tenderId");
            var lotFilter = impactX.isDefined(searchFilter, "searchFilterData.lotId");
            var vcatFilter = impactX.isDefined(searchFilter, "searchFilterData.vcatalogId");
            var supplierFilter = impactX.isDefined(searchFilter, "searchFilterData.supplierId");
            var manufacturerFilter = impactX.isDefined(searchFilter, "searchFilterData.manufacturerId");
            var selectedEClass = impactX.isDefined(searchFilter, "selectedEClass");
            searchFilter.searchFilterData = tempData.data;
            searchFilter.searchFilterData.procurementGroup = procurementGroup;
            searchFilter.searchFilterData.productFamily = productFamily;
            searchFilter.searchFilterData.tenderId = tenderFilter;
            searchFilter.searchFilterData.lotId = lotFilter;
            searchFilter.searchFilterData.vcatalogId = vcatFilter;
            searchFilter.searchFilterData.supplierId = supplierFilter;
            searchFilter.searchFilterData.manufacturerId = manufacturerFilter;
            searchFilter.selectedEClass = selectedEClass;
            searchFilter.trns = tempData.trns;
            var searchFilterData = searchFilter.searchFilterData;
            if (searchFilterData) {
                searchFilterData.drillDowns = [];
            }
        });
        return searchFilter.promise;
    }

    function updateSearchFilter() {
        var tempData = {};
        searchFilter.wasInitialized = true;
        searchFilter.promise = dataGen.getData(tempData, {}, "/search/filter").then(function () {
            searchFilter.wasInitialized = true;

            searchFilter.searchFilterData = tempData.data;
            searchFilter.trns = tempData.trns;
            searchFilter.selectedEClass = null;
            var searchFilterData = searchFilter.searchFilterData;
            if (searchFilterData) {
                searchFilterData.drillDowns = [];
            }
        });
        return searchFilter.promise;
    }

    this.initSearchFilter = function () {
        if (!searchFilter.wasInitialized) {
            return updateSearchFilter();
        }
        else {
            if (searchFilter.promise) {
                return searchFilter.promise;
            }
        }
        return $q.when();
    };
    this.resetSearchFilter = function () {
        return updateSearchFilter();
    };

    this.getSearchFilterData = function () {
        if (searchFilter.searchFilterData) {
            if (!searchFilter.searchFilterData.searchInput) {
                searchFilter.searchFilterData.searchInput = {};
            }
            searchFilter.searchFilterData.searchInput.value = this.otherSearchInput ? this.otherSearchInput : this.searchInput;
            if(impactX.isDefined(searchFilter, "selectedEClass.id")) {
                searchFilter.searchFilterData.productGroupId = impactX.isDefined(searchFilter, "selectedEClass.id");
            } else {
                delete searchFilter.searchFilterData.productGroupId;
            }
            //Warning: Providing reference to global filter data! Possible side-effects
            return searchFilter.searchFilterData;
        }
        return {};
    };

    this.setSearchFilterData = function (data) {
        searchFilter.searchFilterData = data;
    };

    this.redirectToDialogOrList = function(redirectToProductList) {
        var listPath = "";
        if (redirectToProductList) {
            listPath = "search.product";
        }
        var filterData = searchFilter.getSearchFilterData();
        if (impactX.isDefined(filterData, "tenderId.value")) {
            $redirect.redirectTo(null, listPath + "/tender/" + filterData.tenderId.value);
        }
        else if (impactX.isDefined(filterData, "lotId.value")) {
            $redirect.redirectTo(null, listPath + "/lot/" + filterData.lotId.value);
        }
        else if (impactX.isDefined(filterData, "vcatalogId.value")) {
            var vcatPath = redirectToProductList ? listPath + "/vcat/" : "/vcatalog/";
            $redirect.redirectTo(null, vcatPath + filterData.vcatalogId.value);
        }
        else if (impactX.isDefined(filterData, "supplierId.value")) {
            $redirect.redirectTo(null, listPath + "/supplier/" + filterData.supplierId.value);
        }
        else if (impactX.isDefined(filterData, "manufacturerId.value")) {
            $redirect.redirectTo(null, listPath + "/manufacturer/" + filterData.manufacturerId.value);
        }
        else if (redirectToProductList) {
            $redirect.redirectTo(null, "search.product");
        }
        else {
            $redirect.redirectTo(null, "search.all");
        }
    };

    function setEmptyValue(object) {

        if (typeof object === 'object') {
            object.value = '';
        }
    }

    function setEmptySelected(object) {

        if (typeof object === 'object') {
            if (object.selected) {
                object.selected.id = null;
            }
            else {
                object.selected = {
                    id: null
                };
            }
        }
    }

    function init(searchFilterInputs) {
        searchFilterInputs.searchInput = '';
        searchFilterInputs.otherSearchInput = undefined;
        // searchFilterInputs.searchFilterData = {};

        //First init
        if (impactX.isEmptyObject(searchFilterInputs.searchFilterData) && !searchFilter.wasInitialized) {
            //Some defaults as fallback
            searchFilterInputs.searchFilterData = {
                supplier: {
                    label: 'Supplier',
                    value: ''
                },
                manufacturer: {
                    label: 'Manufacturer',
                    value: ''
                },
                contractNo: {
                    label: 'Contract Number',
                    value: ''
                },
                supplierNo: {
                    label: 'Supplier Number',
                    value: ''
                },
                priceRange: {
                    minValue: 0,
                    maxValue: 1000
                },
                filters: {
                    label: 'Filters',
                    selected: {
                        id: null
                    }
                },
                category: {
                    label: 'Category',
                    selected: {
                        id: null
                    }
                },
                tenderId: {
                    label: 'Tender ID',
                    value: ''
                },
                lotId: {
                    label: 'Lot ID',
                    value: ''
                },
                supplierId: {
                    label: 'Supplier ID',
                    value: ''
                },
                vcatalogId: {
                    label: 'User catalog ID',
                    value: ''
                },
                productGroupId: {
                    label: 'Product group ID',
                    value: ''
                },
                cmrlId: {
                    label: '???',
                    value: ''
                },
                country: {
                    label: 'Country',
                    selected: {
                        id: null
                    }
                },
                drillDowns: [],
                forProductView: false
            };
        }
        //Clear always!
        setEmptyValue(searchFilterInputs.searchFilterData.supplier);
        setEmptyValue(searchFilterInputs.searchFilterData.manufacturer);
        setEmptyValue(searchFilterInputs.searchFilterData.contractNo);
        setEmptyValue(searchFilterInputs.searchFilterData.supplierNo);
        setEmptySelected(searchFilterInputs.searchFilterData.filters);
        setEmptySelected(searchFilterInputs.searchFilterData.category);
        setEmptyValue(searchFilterInputs.searchFilterData.tenderId);
        setEmptyValue(searchFilterInputs.searchFilterData.lotId);
        setEmptyValue(searchFilterInputs.searchFilterData.vcatalogId);
        setEmptyValue(searchFilterInputs.searchFilterData.productGroupId);
        setEmptyValue(searchFilterInputs.searchFilterData.cmrlId);
        searchFilterInputs.selectedEClass = {};

        // searchFilterInputs.searchFilterData.supplier = {};
        // searchFilterInputs.searchFilterData.supplier.value = '';
        // searchFilterInputs.searchFilterData.manufacturer = {};
        // searchFilterInputs.searchFilterData.manufacturer.value = '';
        // searchFilterInputs.searchFilterData.contractNo = {};
        // searchFilterInputs.searchFilterData.contractNo.value = '';
        // searchFilterInputs.searchFilterData.supplierNo = {};
        // searchFilterInputs.searchFilterData.supplierNo.value = '';
        // searchFilterInputs.searchFilterData.priceRange = {};
        // searchFilterInputs.searchFilterData.priceRange.minValue = 0;
        // searchFilterInputs.searchFilterData.priceRange.maxValue = 1000;
        // searchFilterInputs.searchFilterData.filters = {};
        // searchFilterInputs.searchFilterData.filters.selected = {};
        // searchFilterInputs.searchFilterData.filters.selected.id = null;
        // searchFilterInputs.searchFilterData.category = {};
        // searchFilterInputs.searchFilterData.category.selected = {};
        // searchFilterInputs.searchFilterData.category.selected.id = null;
        // searchFilterInputs.searchFilterData.tenderId = {};
        // searchFilterInputs.searchFilterData.lotId = {};
        // searchFilterInputs.searchFilterData.supplierId = {};
        // searchFilterInputs.searchFilterData.vcatalogId = {};
        // searchFilterInputs.searchFilterData.cmrlId = {};
    }

    this.deleteSearchFilterData = function () {
        init(searchFilter);
    };

    function setContextFilters($routeParams, forProductView) {
        searchFilter.getSearchFilterData().tenderId.value = $routeParams.tenderId;
        searchFilter.getSearchFilterData().lotId.value = $routeParams.lotId;
        searchFilter.getSearchFilterData().vcatalogId.value = $routeParams.vcatId;
        searchFilter.getSearchFilterData().supplierId.value = $routeParams.supplierId;
        searchFilter.getSearchFilterData().manufacturerId.value = $routeParams.manufacturerId;
        searchFilter.getSearchFilterData().forProductView = !!forProductView;
    }

    this.updateContextFilter = function ($routeParams, forProductView) {
        return searchFilter.initSearchFilter().then(function () {
            setContextFilters($routeParams, forProductView);
            return $q.when();
        });
    };

    this.deSelectLowerDrillDownsIfSet = function (item) {
        if (item.level > 0 && searchFilter.exists(item) && searchFilter.searchFilterData) {
            var indexToRemove = -1;
            var drillDowns = searchFilter.searchFilterData.drillDowns;
            angular.forEach(drillDowns, function (value, key) {
                if (value.patId == item.patId && value.level > item.level) {
                    indexToRemove = key;
                }

            });
            if (indexToRemove >= 0) {
                drillDowns.splice(indexToRemove, 1);
                searchFilter.deSelectLowerDrillDownsIfSet(item);
            }
        }
    };

    this.toggleDrillDown = function (item) {
        if (searchFilter.searchFilterData) {
            searchFilter.deSelectLowerDrillDownsIfSet(item);
            var indexToRemove = -1;
            var drillDowns = searchFilter.searchFilterData.drillDowns;
            angular.forEach(drillDowns, function (value, key) {
                if (value.pathHashString == item.pathHashString) {
                    indexToRemove = key;
                }

            });
            if (indexToRemove >= 0) {
                drillDowns.splice(indexToRemove, 1)
            }
            else {
                drillDowns.push(item)
            }
        }
    };


    this.exists = function (item) {
        var index = -1;
        if (searchFilter.searchFilterData) {
            angular.forEach(searchFilter.searchFilterData.drillDowns, function (value, key) {
                if (value.pathHashString == item.pathHashString) {
                    index = key;
                }

            });
        }
        return index > -1;
    };

    this.currentPage = '/search.all';
    this.pageSearchAll = '/search.all';
    this.pageSearchTender = '/search.tender';
    this.pageSearchThemeWorld = '/search.themeworld';
    this.pageSearchLot = '/search.lot';
    this.pageSearchCatalog = '/search.catalog';
    this.pageSearchProduct = '/search.product';
    this.pageSearchSupplier = '/search.supplier';
    this.pageSearchManufacturer = '/search.manufacturer';

    this.resetDetailFilter = function () {
        this.wasInitialized = false;
        return resetDetailFilter();
    };

    this.reset = function () {
        this.wasInitialized = false;
        return updateSearchFilter();
    };

    this.clearSearchInput = function () {
        searchFilter.searchInput = '';
        searchFilter.otherSearchInput = undefined;
        SearchFilter.resetSearchInput();
    };

    this.activateTenderFilter = function (tenderId) {
        searchFilter.getSearchFilterData().tenderId.value = tenderId;
        searchFilter.getSearchFilterData().lotId.value = undefined;
        searchFilter.getSearchFilterData().vcatalogId.value = undefined;
        searchFilter.getSearchFilterData().supplierId.value = undefined;
        searchFilter.getSearchFilterData().manufacturerId.value = undefined;
        searchFilter.productGroupId = undefined;
    };

    this.activateLotFilter = function (lotId) {
        searchFilter.getSearchFilterData().tenderId.value = undefined;
        searchFilter.getSearchFilterData().lotId.value = lotId;
        searchFilter.getSearchFilterData().vcatalogId.value = undefined;
        searchFilter.getSearchFilterData().supplierId.value = undefined;
        searchFilter.getSearchFilterData().manufacturerId.value = undefined;
        searchFilter.productGroupId = undefined;
    };

    this.activateVCatalogFilter = function (vcatId) {
        searchFilter.getSearchFilterData().tenderId.value = undefined;
        searchFilter.getSearchFilterData().lotId.value = undefined;
        searchFilter.getSearchFilterData().vcatalogId.value = vcatId;
        searchFilter.getSearchFilterData().supplierId.value = undefined;
        searchFilter.getSearchFilterData().manufacturerId.value = undefined;
        searchFilter.productGroupId = undefined;
    };

    this.activateSupplierFilter = function (supplierId) {
        searchFilter.getSearchFilterData().tenderId.value = undefined;
        searchFilter.getSearchFilterData().lotId.value = undefined;
        searchFilter.getSearchFilterData().vcatalogId.value = undefined;
        searchFilter.getSearchFilterData().supplierId.value = supplierId;
        searchFilter.getSearchFilterData().manufacturerId.value = undefined;
        searchFilter.productGroupId = undefined;
    };

    this.activateManufacturerFilter = function (manufacturerId) {
        searchFilter.getSearchFilterData().tenderId.value = undefined;
        searchFilter.getSearchFilterData().lotId.value = undefined;
        searchFilter.getSearchFilterData().vcatalogId.value = undefined;
        searchFilter.getSearchFilterData().supplierId.value = undefined;
        searchFilter.getSearchFilterData().manufacturerId.value = manufacturerId;
        searchFilter.productGroupId = undefined;
    };

    this.removeFixedFilter = function () {
        searchFilter.getSearchFilterData().tenderId.value = undefined;
        searchFilter.getSearchFilterData().tenderId.stringValue = undefined;
        searchFilter.getSearchFilterData().lotId.value = undefined;
        searchFilter.getSearchFilterData().lotId.stringValue = undefined;
        searchFilter.getSearchFilterData().vcatalogId.value = undefined;
        searchFilter.getSearchFilterData().vcatalogId.stringValue = undefined;
        searchFilter.getSearchFilterData().supplierId.value = undefined;
        searchFilter.getSearchFilterData().supplierId.stringValue = undefined;
        searchFilter.getSearchFilterData().manufacturerId.value = undefined;
        searchFilter.getSearchFilterData().manufacturerId.stringValue = undefined;
    }
}]);